/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseOralExamTimeSlotStateResponseData } from './genericApiResponseOralExamTimeSlotStateResponseData';
import type { GenericApiResponseOralExamTimeSlotStateResponseMessage } from './genericApiResponseOralExamTimeSlotStateResponseMessage';
import type { GenericApiResponseOralExamTimeSlotStateResponsePagination } from './genericApiResponseOralExamTimeSlotStateResponsePagination';
import type { GenericApiResponseOralExamTimeSlotStateResponseError } from './genericApiResponseOralExamTimeSlotStateResponseError';

export interface GenericApiResponseOralExamTimeSlotStateResponse {
  data?: GenericApiResponseOralExamTimeSlotStateResponseData;
  message?: GenericApiResponseOralExamTimeSlotStateResponseMessage;
  pagination?: GenericApiResponseOralExamTimeSlotStateResponsePagination;
  error?: GenericApiResponseOralExamTimeSlotStateResponseError;
  statusCode?: number;
}
